import * as React from 'react';

import { CombinedProductionViewProps } from '../../components/list/production';
import ListPerformances from '../../components/list/performances';

const ListMonthsView: React.StatelessComponent<CombinedProductionViewProps> = props => {

    return (
        <li className="ace-subs-item">
            <div className="ace-production grid grid-4-8">

                <div className="ace-image" aria-hidden="true">
                    {
                        props.production.pdpImageSrc ?
                            <img src={props.production.pdpImageSrc} alt={props.production.pdpImageAltText} />
                            : null
                    }

                </div>
                <div className="ace-production-content stack-lg">
                    <div className={`ace-production-heading stack-sm ${props.themeClass}`}>
                        {
                            <h3 id={`Prod-Group-${props.production.productionTitle}`}>
                                {props.production.productionTitle}
                            </h3>
                        }

                        {
                            props.text.hideVenues ? null :
                                props.text.venueOverride != null && props.text.venueOverride.trim() != "" ?
                                    <p className="h6-style themed-location notranslate">
                                        <svg className="svg-icon svg-icon-text" aria-hidden="true" focusable="false">
                                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-location"></use>
                                        </svg>
                                        <span className="icon-location-title">{props.text.venueOverride}</span>
                                    </p> :
                                    props.production.facility != null ?
                                        <p className="h6-style themed-location">
                                            <svg className="svg-icon svg-icon-text" aria-hidden="true" focusable="false">
                                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-location"></use>
                                            </svg>
                                            <span className="icon-location-title notranslate">{props.production.facility.facilityDescription}</span>
                                        </p>
                                        : null
                        }
                        <p className="large">
                            {props.production.dateRangeString}
                        </p>
                        <div className="">
                            {props.production.productionSynopsis ?
                                <div className="rich-text small space-top-sm" dangerouslySetInnerHTML={{ __html: props.production.productionSynopsis }} />
                                : null
                            }
                        </div>
                    </div>
                    <div className="ace-production-ctas spaced-list">
                        <p className="ace-production-ctas-primary">
                            <button className={`btn-secondary dropdown-trigger ${props.showPerformances ? 'dropdown-trigger-up' : 'dropdown-trigger-down'}`} onClick={props.toggleShowPerformances}>
                                {
                                    props.showPerformances ? props.text.hidePerformancesText
                                        : props.text.showPerformancesText
                                }
                            </button>
                        </p>
                    </div>
                    <div className={props.showPerformances ? "show" : "hide"} >
                        <div className="ace-production stack">

                            <div className="ace-production-content stack">
                                <ListPerformances filteredPerformances={props.filteredPerformances} toggleShowPerformances={props.toggleShowPerformances} />
                            </div>
                        </div>
                    </div>

                    {
                        props.showProductionAddedToCart ?
                            <div className="ace-alert-inner theme-green">
                                <svg className="svg-icon ace-alert-indicator" aria-hidden="true" focusable="false">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-success"></use>
                                </svg>
                                <span>{props.text.productionInCartMessage}</span>
                            </div> : null
                    }
                </div>
            </div>
        </li>
    );
}

export default ListMonthsView;